import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';

const userTestimonials = [
  {
    avatar: <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />,
    // name: 'Remy Sharp',
    occupation: 'GPST3',
    testimonial:
      'As a GPST3, I found the cases on this website to be incredibly accurate and closely aligned with the SCA exam. The quality of the cases is fantastic—they cover all the essential topics and give you the experience you need for the real exam. What’s more, the price is incredibly affordable compared to other resources, and it’s not an either/or situation. You can easily use this site alongside other materials without breaking the bank. Highly recommended for anyone serious about their SCA prep!'
  },
  {
    avatar: <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />,
    // name: 'Travis Howard',
    occupation: 'GPST3',
    testimonial:
      'The layout of the website is so intuitive and easy to use. I love the tracking system—it’s incredibly helpful for keeping tabs on which cases I’ve completed and which ones I need to revisit. The cases are very realistic, reflecting what you’d encounter in the actual SCA exam. I feel much more confident knowing I’ve had the chance to go through these high-quality cases. Great value for the price!'
  },
  {
    avatar: <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />,
    // name: 'Cindy Baker',
    occupation: 'GPST2',
    testimonial:
      'As a GPST2, I’ve found this site to be an invaluable resource in my preparation for the SCA exam. I’m hoping to sit it early in ST3. The cases are extremely relevant and provide a great variety of scenarios. I especially appreciate the ability to track my progress and revisit areas where I need improvement. The site is affordable and easy to use, and it complements other resources I’m using for my exam prep. It’s hard to beat the combination of quality and price.'
  },
  {
    avatar: <Avatar alt="Julia Stewart" src="/static/images/avatar/4.jpg" />,
    // name: 'Julia Stewart',
    occupation: 'GP Trainer',
    testimonial:
      "I’ve recommended this site to all my GP trainees. As a GP trainer, I can vouch for how realistic and representative the cases are of the actual SCA exam. The cases cover a wide range of topics that are crucial for the exam and provide the practice that trainees need. Plus, the site is very user-friendly, and the price is unbeatable. It's a fantastic resource that every GPST should use."
  },
  {
    avatar: <Avatar alt="Atif Ali" src="/static/images/avatar/5.jpg" />,
    // name: 'John Smith',
    occupation: 'GP Trainer',
    testimonial:
      'This site is a must-have for GP trainees preparing for the SCA exam. The quality of the cases is excellent, and the variety of scenarios ensures that all the key exam topics are covered. I’ve been really impressed with how easy it is to navigate and track progress, making it easy for trainees to know where to focus. The best part? It’s incredibly affordable, so it’s accessible for all trainees without having to choose between different resources.'
  },
  {
    avatar: <Avatar alt="Saqib Ali" src="/static/images/avatar/6.jpg" />,
    // name: 'Daniel Wolf',
    occupation: 'GPST3',
    testimonial:
      'I’ve used a few different websites to prepare for my SCA exam, but this one stands out. The cases are realistic and in-depth, providing a true-to-exam experience. The layout is sleek and simple to use, and the tracking system is a huge help in identifying areas for improvement. Plus, at such a competitive price, it’s a no-brainer to use alongside other resources. This site really helps solidify your preparation.'
  }
];

// const whiteLogos = [
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628e8573c43893fe0ace_Sydney-white.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d520d0517ae8e8ddf13_Bern-white.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f46794c159024c1af6d44_Montreal-white.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e891fa22f89efd7477a_TerraLight.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a09d1f6337b1dfed14ab_colorado-white.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5caa77bf7d69fb78792e_Ankara-white.svg'
// ];

// const darkLogos = [
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628889c3bdf1129952dc_Sydney-black.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d4d8b829a89976a419c_Bern-black.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f467502f091ccb929529d_Montreal-black.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e911fa22f2203d7514c_TerraDark.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a0990f3717787fd49245_colorado-black.svg',
//   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5ca4e548b0deb1041c33_Ankara-black.svg'
// ];

// const logoStyle = {
//   width: '64px',
//   opacity: 0.3
// };

export default function Testimonials() {
  const theme = useTheme();
  // const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 }
      }}>
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' }
        }}>
        <Typography component="h2" variant="h4" color="text.primary">
          Testimonials
        </Typography>
        <Typography variant="body1" color="text.secondary">
          See what our users love about us.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
                p: 1
              }}>
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  pr: 2
                }}>
                <CardHeader
                  avatar={testimonial.avatar}
                  title={testimonial.name}
                  subheader={testimonial.occupation}
                />
                {/* <img src={logos[index]} alt={`Logo ${index + 1}`} style={logoStyle} /> */}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
